<template>
  <div class="lanage">
    <!-- <img
        :src="exitImg"
        alt="语言选择"
        class="logout-btn"
        @click="visible = true"
    > -->
    <div class="lanbtn" @click="dlgVisible = true">
      {{ rnrLanage }}
    </div>
    <van-popup :value="dlgVisible">
      <van-picker
        :columns="lanageOptions"
        value-key="name"
        title="lanage"
        show-toolbar
        @confirm="handleChange"
        @cancel="handleCancel"
      />
    </van-popup>
  </div>
</template>

<script>
// import { ref } from 'vue'
import { RNR_LANAGE } from '@/store/modules/rnr'
import { convertLanage } from '@/utils/lanage'
import store from '@/store'
// const { LANAGE_LIST } = this.$store.getters.dict
export default ({
  name: 'LanageSet',
  data() {
    return {
      lanageOptions: [
        { name: convertLanage('繁体中文'), value: 'hk' }, // 繁体
        { name: '简体中文', value: 'cn' } // 简体
      ],
      rnrLanage: (store.getters.lanage === 'hk') ? convertLanage('繁体中文') : '简体中文',
      dlgVisible: false
    }
  },
  methods: {
    /**
     * 简繁体语言转换
     */
    convertLanage(strs) {
      return convertLanage(strs)
    },
    handleChange(value) {
      console.log('lanageValue', value)
      this.handleLanage(value.value)
      // 关闭弹框
      this.dlgVisible = false
    },
    handleCancel() {
      this.dlgVisible = false
    },
    /**
     * 当前点击选择的语言
     * @param lan 所选语言
     */
    handleLanage(lan) {
      try {
        switch (lan) {
          case 'hk': // 繁体中文
            // this.$store.dispatch('rnr/RNR_LANAGE', 'hk')
            this.$store.commit(`rnr/${RNR_LANAGE}`, 'hk')
            this.rnrLanage = convertLanage('繁体中文')
            break
          case 'cn': // 简体中文
            // this.$store.dispatch('rnr/RNR_LANAGE', 'cn')
            this.$store.commit(`rnr/${RNR_LANAGE}`, 'cn')
            this.rnrLanage = '简体中文'
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  .lanage {
    position: absolute;
    top: -70px;
    left: 20px;
    z-index: 5;
    .lanbtn {
      width: 140px;
      height: 48px;
      margin-top: 82px;
      line-height: 48px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LanageSet/index.vue